import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 16px 24px;
`;
